import { AllPersonnelThemeSizeConfig } from './types';

const medium: AllPersonnelThemeSizeConfig = {
  allPersonnel: {},
};

export default medium;
